import { createAction, createAsyncAction } from 'typesafe-actions';
import * as payloads from './payloads';

export const getExtensionCallHistory = createAsyncAction(
    'GET_EXTENSION_CALL_HISTORY',
    'GET_EXTENSION_CALL_HISTORY_SUCCESS',
    'GET_EXTENSION_CALL_HISTORY_FAILED',
)<
    payloads.GetExtensionCallHistoryRequestPayload,
    payloads.GetCallHistoryResponsePayload,
    undefined
>();

export const getExtensionCallHistoryFile = createAsyncAction(
    'GET_EXTENSION_CALL_HISTORY_FILE',
    'GET_EXTENSION_CALL_HISTORY_FILE_SUCCESS',
    'GET_EXTENSION_CALL_HISTORY_FILE_FAILED',
)<payloads.GetExtensionCallHistoryFileRequestPayload, undefined, undefined>();

export const setCustomerCurrencyForCallHistory = createAction(
    'SET_CUSTOMER_CURRENCY_FOR_CALL_HISTORY',
)<payloads.SetCustomerCurrencyForCallHistoryPayload>();

export const getCallHistory = createAsyncAction(
    'GET_CALL_HISTORY',
    'GET_CALL_HISTORY_SUCCESS',
    'GET_CALL_HISTORY_FAILED',
)<
    payloads.GetCallHistoryRequestPayload,
    payloads.GetCallHistoryResponsePayload,
    undefined
>();

export const removeCallRecordings = createAsyncAction(
    'REMOVE_CALL_RECORDING',
    'REMOVE_CALL_RECORDING_SUCCESS',
    'REMOVE_CALL_RECORDING_FAILED',
)<payloads.RemoveCallRecoringsRequestPayload, undefined, undefined>();

export const getActiveCalls = createAsyncAction(
    'GET_ACTIVE_CALLS',
    'GET_ACTIVE_CALLS_SUCCESS',
    'GET_ACTIVE_CALLS_FAILED',
)<undefined, payloads.GetActiveCallsResponsePayload, undefined>();

export const getCallHistoryBasicData = createAsyncAction(
    'GET_CALL_HISTORY_BASIC_DATA',
    'GET_CALL_HISTORY_BASIC_DATA_SUCCESS',
    'GET_CALL_HISTORY_BASIC_DATA_FAILED',
)<undefined, payloads.GetCallHistoryBasicDataResponsePayload, undefined>();
